module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-Black.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-Black.woff
 ** module id = 1101
 ** module chunks = 0
 **/